import { PaymentMethodType } from '@nemuru-eng/checkout-js';
import { getCardPaymentById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { SinglePaymentDetails } from '@/components/modules/SinglePayment/_shared/components/SinglePaymentDetails';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const CardPayment = () => {
  const { paymentMethodId } = useParams();

  if (!paymentMethodId) return null;

  const { data: cardPaymentDetails, loading: loadingCardPayment } = useCache(getCardPaymentById, {
    cardPaymentId: paymentMethodId,
  });

  useSetPageLoadingWhenRequesting('CARD_PAYMENT_DETAIL', [loadingCardPayment]);

  if (!cardPaymentDetails) return null;

  return <SinglePaymentDetails singlePayment={cardPaymentDetails} paymentMethodType={PaymentMethodType.CARD_PAYMENT} />;
};

export const CardPaymentModule = withPermissionsModule(CardPayment);
